import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginLayoutComponent } from "./login-layout/login-layout.component";
import { LoginPageComponent } from "./pages/login-page/login-page.component";
import { ForgotPasswordPageComponent } from "./pages/forgot-password-page/forgot-password-page.component";
import { SetNewPasswordComponent } from './pages/set-new-password/set-new-password.component';
import { SetOwnPasswordComponent } from './pages/set-own-password/set-own-password.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { ForgotPasswordAfterloginComponent } from './pages/forgot-password-afterlogin/forgot-password-afterlogin.component';
import { CreateNewPasswordComponent } from './pages/create-new-password/create-new-password.component';
import { AccountDetailsComponent } from './pages/account-details/account-details.component';
// import { AdminDashboardComponent } from "../home/pages/admin-dashboard/admin-dashboard.component";
//import { HomeLayoutComponent } from "../home/home-layout/home-layout.component";
import { AccountInfoComponent } from './pages/account-info/account-info.component';
import { AccountMgaComponent } from './pages/account-mga/account-mga.component';
import { GotoGetReliableComponent } from './pages/goto-get-reliable/goto-get-reliable.component';
import { PaymentLinkComponent } from './pages/payment-link/payment-link.component';
import {ChangeOldPasswordComponent} from './pages/change-old-password/change-old-password.component'
import { BrokerRedirectComponent } from './pages/broker-redirect/broker-redirect.component';
const routes: Routes = [
  {
    path: "",
    component: LoginLayoutComponent,
    children: [
      {
        path: "",
        component: LoginPageComponent
      },
      //  {
      //   path: "/set-own-password",
      //   component: SetOwnPasswordComponent
      // },
      {
        path: "login",
        component: LoginPageComponent
      },
      {
        path: "forgot-password",
        component: ForgotPasswordPageComponent
      },
      {
        path: "set-new-password",
        component: SetNewPasswordComponent
      },
      {
        path: "set-own-password",
        component: SetOwnPasswordComponent
      },
      {
        path: "change-password",
        component: ChangePasswordComponent
      },
      {
        path: "forgot-password-alogin",
        component: ForgotPasswordAfterloginComponent
      },
      {
        path: "create-new-password",
        component: CreateNewPasswordComponent
      },
      {
        path: "account-details",
        component: AccountDetailsComponent
      },
      {
        path: "account-info",
        component: AccountInfoComponent
      },
      {
        path: "activated",
        component: AccountMgaComponent
      },
      {
        path: "goto-get-reliable",
        component: GotoGetReliableComponent
      },
      {
        path:"isp-payment-link",
        component: PaymentLinkComponent
      },
      {
        path:"change-old-password",
        component: ChangeOldPasswordComponent
      },
      {
        path: "broker-redirect",
        component: BrokerRedirectComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
